const header = {
  role: 'Role',
  myProfile: 'My Profile',
  language: 'Language',
  signOut: 'Sign Out',
  switchCustomer: 'Switch Customer'
};

export default header;
